<template>
  <div class="container-fluid container-user-list">
    <div class="row">
      <div class="col flex-grow-1" style="max-width: 400px;">
        <div class="input-group">
          <input
            v-model="searchQuery"
            type="text"
            id="user-search"
            class="form-control"
            placeholder="Buscar usuario..."
          />
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="clearSearch"
            :disabled="!searchQuery"
            aria-label="Limpiar búsqueda"
            title="Limpiar">
            <i class="icon-close-cross-link icon-text"></i>
          </button>
        </div>
      </div>
      <div class="col-auto ms-auto">
        <a :href="newUserUrl">
          <button type="button" class="btn btn-primary">
            Nuevo usuario
          </button>
        </a>
      </div>
    </div>
    <table class="table mt-2">
      <thead>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Nombre</th>
          <th scope="col">E-mail</th>
          <th scope="col">Rol</th>
          <th scope="col">Edificio</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in filteredUsers" :key="user.id">
          <th scope="row">{{ user.id }}</th>
          <td>
            <a :href="user.detailsUrl">{{ user.name }}</a>
          </td>
          <td>{{ user.email }}</td>
          <td>{{ user.roleName }}</td>
          <td>{{ user.edificioNombre }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  props: {
    users: {
      type: Array,
      required: true,
    },
    newUserUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }
      const query = this.searchQuery.toLowerCase();
      return this.users.filter((user) =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    clearSearch() {
      this.searchQuery = '';
    },
  },
};
</script>

<style scoped>
</style>
